import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import AvatarName from '@/components/ui/custom/dataDisplay/AvatarName';
import Text from '@/components/ui/custom/dataDisplay/Text';
import { Project } from '@/models/Project';
import { ROUTES } from '@/utils/routes';
import { AcademicCapIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

type OwnersProps = Pick<Project, 'equipName' | 'teacherMentor' | 'users'>;
export default function CompleteOwners({
  users,
  equipName,
  teacherMentor,
}: OwnersProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'projects.card',
  });

  return (
    <div className="flex flex-col gap-1">
      <div className="p-1 bg-hackathon-primary/10 rounded-[4px] flex flex-col gap-1 border-hackathon-primary border">
        <ConditionalRenderer condition={!!equipName}>
          <div className="flex gap-1">
            <UserGroupIcon className="w-4 h-4" />
            <Text text={equipName} format="rubik-500" className="inline-flex" />
          </div>
        </ConditionalRenderer>

        <ul className="flex flex-col gap-0.5 flex-wrap justify-end ml-1.5">
          {users.map(user => (
            <AvatarName
              className="gap-1.5"
              textClassName="text-wrap w-full"
              user={user}
              key={user.id}
              href={ROUTES.PROFILE.INFO(user.username)}
            />
          ))}
        </ul>
      </div>

      <div className="p-1 bg-hackathon-secondary/10 border-hackathon-secondary border rounded-[4px] flex flex-col gap-1">
        <ConditionalRenderer condition={!!teacherMentor}>
          <div className="flex gap-1.5 items-center">
            <AcademicCapIcon className="w-4 h-4" />
            <Text text={t('mentor')} />
          </div>
          {teacherMentor && (
            <AvatarName user={teacherMentor} className="ml-1.5 gap-1.5" />
          )}
        </ConditionalRenderer>
      </div>
    </div>
  );
}
